export const  SET_LOADER = "SET_LOADER";
export const SET_COMPONENT_LOADER ="SET_COMPONENT_LOADER";
export const CASE_STATUS_LOADER = "CASE_STATUS_LOADER";
export const PROVIDER_STATUS_LOADER = "PROVIDER_STATUS_LOADER";